type ValueType = object | string | number | null | undefined;

/** Returns the value if it is defined. Otherwise returns the fallback. */
export default function <T extends ValueType>(value: T, fallback = 'N/A') {
  return value === undefined || value === null || value === ''
    ? fallback
    : value;
}
